import React, { useState } from 'react';
import { Link as RouterLink, withRouter } from 'react-router-dom';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import {
	AppBar,
	Toolbar,
	Hidden,
	IconButton,
	Typography,
} from '@material-ui/core';
import MenuIcon from '@material-ui/icons/Menu';
import InputIcon from '@material-ui/icons/Input';

import { connect } from 'react-redux';
import { setCurrentUser } from 'actions';

import { COOKIE_NAME } from 'utils/constants';

const useStyles = makeStyles(theme => ({
	root: {
		boxShadow: 'none',
	},
	flexGrow: {
		flexGrow: 1,
	},
	signOutButton: {
		marginLeft: theme.spacing(1),
	},
}));

const Topbar = props => {
	const {
		className,
		onSidebarOpen,
		staticContext,
		setCurrentUser,
		...rest
	} = props;

	const classes = useStyles();

	const [notifications] = useState([]);

	const logoutAction = () => {
		setCurrentUser(null);

		// Clear Cookie
		document.cookie =
			COOKIE_NAME + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';

		props.history.push('/sign-in');
	};

	return (
		<AppBar {...rest} className={clsx(classes.root, className)}>
			<Toolbar>
				<RouterLink to='/'>
					<Typography variant='h3' style={{ color: '#FFF' }}>
						Kitpet
					</Typography>
				</RouterLink>
				<div className={classes.flexGrow} />
				<Hidden mdDown>
					<IconButton
						className={classes.signOutButton}
						color='inherit'
						onClick={logoutAction}
					>
						<InputIcon />
					</IconButton>
				</Hidden>
				<Hidden lgUp>
					<IconButton color='inherit' onClick={onSidebarOpen}>
						<MenuIcon />
					</IconButton>
				</Hidden>
			</Toolbar>
		</AppBar>
	);
};

Topbar.propTypes = {
	className: PropTypes.string,
	onSidebarOpen: PropTypes.func,
};

export default connect(null, { setCurrentUser })(withRouter(Topbar));
